/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CustomerInfo {
  currency: string;
  isoCurrency: string;
  priceStyle: TiEnumPriceStyle;
  priceStyleOptions: TiEnumPriceStyle[];
  isAcceptAnyOdds: boolean;
  isAcceptAnyCashOutValue: boolean;
  abTestGroup: Record<string, boolean>;
  playerType: PlayerType;
  license: LicenseType;
  accountId: string;
  loginName: string;
  isQ: boolean;
  ipCountryCode: string;
  isEFootballEnabled: boolean;
  isSimulationEnabled: boolean;
  oddsSorting: OddsSorting;
  displayTime: DisplayTime;
  playSound?: string;
  sportSorting?: string;
  oddsDisplayMode: OddsDisplayMode;
  trackingId: string;
  siteStyle: SiteStyle;
  basePath: string;
}

export enum TiEnumPriceStyle {
  Unknown = 0,
  Malay = 1,
  HK = 2,
  Indo = 3,
  Euro = 4,
}

export enum PlayerType {
  B2B = 0,
  B2C = 1,
  B2B2C = 2,
}

export enum LicenseType {
  MNL = 0,
  IOM = 1,
}

export enum OddsSorting {
  Unknown = 0,
  Normal = 1,
  ShowTime = 2,
}

export enum DisplayTime {
  SystemTime = 0,
  LocalTime = 1,
}

export enum OddsDisplayMode {
  Unknown = 0,
  Double = 1,
  Single = 2,
  Simple = 3,
}

export enum SiteStyle {
  Unknown = 0,
  Asia = 1,
  Euro = 2,
}

export interface BannerInfo {
  cdn: string;
  chinaCdn: string;
  action: EnumSportsBannerAction;
  actionDetail?: string;

  /** @format int32 */
  id: number;
  restrictions: BannerRestriction[];
  trackingCode?: string;
  remark?: BannerRemark;
  gameFrom: EnumGameFrom;
}

export enum EnumSportsBannerAction {
  Unknown = 0,
  NoAction = 1,
  ProductSwitch = 2,
  JoinNow = 3,
  ToSport = 4,
  ToSportMarketPage = 5,
  ToSportLeague = 6,
  SimulateClick = 7,
  RouteTo = 8,
  RedirectTo = 9,
  OpenWindow = 10,
  InJoiOpenGame = 11,
  ToPromotionZone = 12,
  InJoiEventPromotion = 13,
  CasinoInGame = 14,
  CasinoToGameLobby = 15,
  CasinoDealerPage = 16,
}

export interface BannerRestriction {
  /** @format int32 */
  subId: number;
  brands: string[];
  licenses: string[];
  countries: string[];
  sboCurrencies: string[];
  memberStatus: string[];
  deviceOs: EnumDeviceOs;
}

export enum EnumDeviceOs {
  Unknown = 0,
  Android = 1,
  iOS = 2,
}

export interface BannerRemark {
  hierarchyWhiteList?: number[];
  hierarchyBlackList?: number[];

  /** @format int32 */
  frequencyHour?: number;
  promotionCode?: string;
}

export enum EnumGameFrom {
  SportsAsiaGameBanner = 10202,
  SportsAsiaCarouselBanner = 10206,
  SportsAsiaLeftSideBanner = 10207,
  GamesDesktopBanner = 10302,
  GamesMobileBanner = 20302,
  SyllisSportsToday = 20705,
  SyllisBsi = 20799,
  TeraMobileSportsBanner = 20815,
  TeraMobileLandingBanner = 20816,
  NativeAppLandingBanner = 60016,
  Unknown = -1,
}

export interface BannerRequest {
  brand: BrandType;
  position: BannerPosition;
  deviceOs?: string;
}

export enum BrandType {
  Unknown = 0,
  SBOTOP = 1,
  SBOBET = 2,
}

export enum BannerPosition {
  NikeTop = 0,
  NikePopUp = 1,
  NikeSide = 2,
  CastorTop = 3,
  KratosAsiaTop = 5,
  KratosAsiaPopUp = 6,
  KratosAsiaSide = 7,
  KratosAsiaMyBetTop = 8,
  CastorMyBetTop = 9,
  KratosEuroTop = 10,
  KratosEuroPopUp = 11,
  KratosEuroMyBetTop = 12,
  Unknown = -1,
}

export interface SendBehaviorsRequest {
  behaviors: Behavior[];
}

export interface Behavior {
  behaviorType: BehaviorType;

  /** @format int32 */
  count: number;

  /** @format int32 */
  durationMinutes: number;
}

export enum BehaviorType {
  Unknown = 0,
  EventsQuery = 1,
  OddsQueryPerEvent = 2,
  OpenTicket = 3,
}

export interface MaxOddsMixParlayBetResponse {
  /** @format int32 */
  stake: number;
  loginName: string;

  /** @format int64 */
  transId: number;

  /** @format decimal */
  odds: number;

  /** @format date-time */
  settlementTime: string;
  subBets: MaxOddsSubBetResponse[];
}

export interface MaxOddsSubBetResponse {
  sportType: TiEnumSportType;
  marketType: TiEnumMarketType;

  /** @format decimal */
  odds: number;

  /** @format float */
  point: number;

  /** @format int32 */
  betTypeGroupId: number;
  oddsOptionType: TiEnumOddsOption;

  /** @format int32 */
  liveHomeScore: number;

  /** @format int32 */
  liveAwayScore: number;
  favoriteTeam: HandicapType;
  homeTeamName: string;
  awayTeamName: string;
  betTeam: string;
  isLive: boolean;
}

export enum TiEnumSportType {
  Unknown = 0,
  Soccer = 1,
  Basketball = 2,
  Football = 3,
  Ice_Hockey = 4,
  Badminton = 5,
  Pool = 6,
  Motor_Sport = 7,
  Tennis = 8,
  Baseball = 9,
  Volleyball = 10,
  Others = 11,
  Golf = 12,
  Boxing = 13,
  Cricket = 14,
  Table_Tennis = 15,
  Rugby = 16,
  Handball = 17,
  Cycling = 18,
  Athletics = 19,
  Beach_Soccer = 20,
  Futsal = 21,
  Entertainment = 22,
  Financial = 23,
  Darts = 24,
  Olympic = 25,
  Lacrosse = 26,
  Water_Polo = 27,
  Winter_Sports = 28,
  Squash = 29,
  General_Hockey = 30,
  Mixed_Martial_Arts = 31,
  E_Sports = 32,
  Gaelic_Football = 33,
  Hurling = 34,
  Muay_Thai = 35,
  Aussie_Rules_Football = 36,
  Bandy = 37,
  Winter_Olympic = 38,
  Beach_Volleyball = 39,
}

export enum TiEnumMarketType {
  Unknown = 0,
  Handicap = 1,
  OddEven = 2,
  OverUnder = 3,
  CorrectScore = 4,
  _1X2 = 5,
  TotalGoal = 6,
  FH_Handicap = 7,
  FH_1X2 = 8,
  FH_OverUnder = 9,
  HTFT = 10,
  MoneyLine = 11,
  FH_OddEven = 12,
  FGLG = 13,
  FH_CorrectScore = 14,
  DoubleChance = 15,
  LiveScore = 16,
  FH_LiveScore = 17,
  Dynamic = 18,
  SH_CorrectScore = 19,
  Game = 38,
  OutRight = 39,
  MixParlay = 40,
  BetBuilder = 41,
}

export enum TiEnumOddsOption {
  Unknown = 0,
  Home = 1,
  Away = 2,
  Over = 3,
  Under = 4,
  Odd = 5,
  Even = 6,
  _1X2_1 = 7,
  _1X2_X = 8,
  _1X2_2 = 9,
  ML_1 = 10,
  ML_2 = 11,
  HTFT_HH = 12,
  HTFT_HA = 13,
  HTFT_HD = 14,
  HTFT_AH = 15,
  HTFT_AA = 16,
  HTFT_AD = 17,
  HTFT_DH = 18,
  HTFT_DA = 19,
  HTFT_DD = 20,
  FGLG_HF = 21,
  FGLG_HL = 22,
  FGLG_AF = 23,
  FGLG_AL = 24,
  FGLG_NG = 25,
  TG_0_1 = 26,
  TG_2_3 = 27,
  TG_4_6 = 28,
  TG_7_Up = 29,
  CS_0_0 = 30,
  CS_0_1 = 31,
  CS_0_2 = 32,
  CS_0_3 = 33,
  CS_0_4 = 34,
  CS_1_0 = 35,
  CS_1_1 = 36,
  CS_1_2 = 37,
  CS_1_3 = 38,
  CS_1_4 = 39,
  CS_2_0 = 40,
  CS_2_1 = 41,
  CS_2_2 = 42,
  CS_2_3 = 43,
  CS_2_4 = 44,
  CS_3_0 = 45,
  CS_3_1 = 46,
  CS_3_2 = 47,
  CS_3_3 = 48,
  CS_3_4 = 49,
  CS_4_0 = 50,
  CS_4_1 = 51,
  CS_4_2 = 52,
  CS_4_3 = 53,
  CS_4_4 = 54,
  CS_HUP5 = 55,
  CS_AUP5 = 56,
  OR = 57,
  DC_1X = 58,
  DC_2X = 59,
  DC_12 = 60,
  GAME_0_0 = 61,
  GAME_0_1 = 62,
  GAME_0_2 = 63,
  GAME_0_3 = 64,
  GAME_0_4 = 65,
  GAME_0_5 = 66,
  GAME_1_0 = 67,
  GAME_1_1 = 68,
  GAME_1_2 = 69,
  GAME_1_3 = 70,
  GAME_1_4 = 71,
  GAME_2_0 = 72,
  GAME_2_1 = 73,
  GAME_2_2 = 74,
  GAME_2_3 = 75,
  GAME_2_4 = 76,
  GAME_3_0 = 77,
  GAME_3_1 = 78,
  GAME_3_2 = 79,
  GAME_3_3 = 80,
  GAME_3_4 = 81,
  GAME_4_0 = 82,
  GAME_4_1 = 83,
  GAME_4_2 = 84,
  GAME_4_3 = 85,
  GAME_4_4 = 86,
  GAME_5_0 = 87,
  LS_1 = 88,
  LS_X = 89,
  LS_2 = 90,
  CS_Others = 91,
}

export enum HandicapType {
  None = 0,
  Home = 1,
  Away = 2,
}

export interface CashOutValueResponse {
  /** @format int64 */
  transactionId: number;
  status: CashOutStatus;

  /** @format decimal */
  cashOutValue: number;
  isSupported: boolean;

  /** @format decimal */
  minStake?: number;
  isSupportedPartialCashOut?: boolean;
}

export enum CashOutStatus {
  Success = 1,
  CallJackTimeNotEnabled = 2,
  InvalidTransactionId = 3,
  InvalidBets = 4,
  ExternalProviderFailure = 5,
  ArgoFailure = 6,
  CashOutValueTooHigh = 7,
  EmptyRequest = 8,
  SettlementInProgress = 9,
  BetSettleApiFailure = 10,
  RemainingStakeIsNotRoundNumber = 11,
  CashoutValueHigherThanPayout = 12,
  CashOutNotAllowed = 13,
  MinStakeForPco = 14,
  RateLimited = 15,
  InternalError = 999,
}

export interface CashOutValuesRequest {
  transactionIds: number[];
}

export interface CashOutResponse {
  /** @format int64 */
  transactionId: number;
  status: CashOutStatus;

  /** @format decimal */
  cashOutValue: number;
}

export interface CashOutRequest {
  /** @format int64 */
  transactionId: number;

  /** @format decimal */
  cashOutValue: number;

  /** @format decimal */
  fullCashOutValue?: number;
}

export enum EnumProject {
  Unknown = 0,
  Kratos = 1,
  Klee = 2,
  Laufey = 3,
  Castor = 4,
}

export interface LocationResponse {
  countryCode: string;
  brand: BrandType;
  isMainDomain: boolean;
}

export interface ExchangeResponseOfBettingPageResponse {
  status: ExchangeStatus;
  data?: BettingPageResponse;
}

export enum ExchangeStatus {
  Unknown = 0,
  Success = 1,
  Error = 2,
  ThirdPartyError = 3,
}

export type BettingPageResponse = CustomerInfoResponse & { iframeUrl?: string };

export interface CustomerInfoResponse {
  /** @format decimal */
  betCredit: number;
  hasBettingBudget: boolean;

  /** @format decimal */
  bettingBudget: number;
  isSuspended: boolean;

  /** @format decimal */
  exchangeBalance: number;
  hasDepositBonus: boolean;
}

export interface ExchangeResponseOfObject {
  status: ExchangeStatus;
  data?: any;
}

export interface TransferRequest {
  /** @format decimal */
  amount: number;
}

export interface ExchangeResponseOfCustomerInfoResponse {
  status: ExchangeStatus;
  data?: CustomerInfoResponse;
}

export interface FeatureEventStateResponse {
  completedEvents: number[];
}

export interface SetFeatureEventRequest {
  event: SportsFeatureEvent;
}

export enum SportsFeatureEvent {
  Unknown = 0,
  SingleModeBetSlipTutorialCompleted = 1,
}

export interface InternalPromotionTeamBet {
  team: string;

  /** @format decimal */
  averageWinLost: number;
}

export enum InternalPromotionStage {
  Group = 1,
  Knockout = 2,
  Ultimate = 3,
}

export interface InternalPromotionSingleBet {
  team: string;
  loginName: string;
  firstName: string;
  lastName: string;

  /** @format decimal */
  totalStake: number;

  /** @format decimal */
  totalWinLost: number;

  /** @format decimal */
  bestReturn: number;

  /** @format decimal */
  mixParlayWinLost: number;

  /** @format int32 */
  matchCount: number;
}

export enum TriggerResult {
  Success = 0,
  NotPendingStatus = 1,
  NoWinnerName = 2,
  LessThan4DaysFromTriggerDate = 3,
  GeneralError = 4,
  NotApprovedStatus = 5,
}

export interface ClaimJackpotRequest {
  poolType: PoolType;

  /** @format int32 */
  round: number;
}

export enum PoolType {
  Unknown = 0,
  Mini = 1,
  Minor = 2,
  Major = 3,
  Mega = 4,
}

export interface LandingLoginResponse {
  dataDomain: string;
  id: string;
}

export interface LandingRequest {
  /** @format int32 */
  customerId: number;
  accountId: string;
  loginCountry: string;
  isIom: boolean;
  isJoinNow: boolean;
  isQuarantined: boolean;
  domain: string;
  isHttps: boolean;
  loginApiToken: string;

  /** @format int64 */
  onlineId?: number;
  requestIdentifier?: string;
  mpMode: boolean;
  sportType: TiEnumSportType;
  page?: string;
}

export interface LandingProductSwitchResponse {
  dataDomain: string;
  landingUrl: string;
}

export interface LiveStreamResponse {
  url: string;

  /** @format int32 */
  errorCode?: number;
  errorMessage?: string;
}

export enum LiveStreamResource {
  BetRadar = 1,
  GLive = 2,
  BetConstruct = 3,
  BetGenius = 4,
}

export interface MatchResponse {
  /** @format int32 */
  matchId: number;
  matchCode: string;

  /** @format int32 */
  leagueId: number;
  leagueName: string;
  homeTeamName: string;
  awayTeamName: string;

  /** @format date-time */
  showTime: string;
  showTimeDisplayType: ShowTimeDisplayType;
  firstGoal: EnumResultFGLG;
  lastGoal: EnumResultFGLG;
  results: MatchResultResponse[];
  hasBetBuilderResults: boolean;
  hasDynamicMarketResults: boolean;
  leaguePriority: string;
  matchCodeWithoutLeaguePriority: string;
}

export enum ShowTimeDisplayType {
  None = 0,
  Date = 1,
  DateTime = 2,
  RedLive = 4,
  BlueLive = 8,
}

export enum EnumResultFGLG {
  Unknown = 0,
  Home = 1,
  Away = 2,
  NoGoal = 3,
}

export interface MatchResultResponse {
  /** @format int32 */
  matchResultId: number;

  /** @format int32 */
  betTypeGroupId: number;
  betTypeGroupName?: string;
  homeOption?: string;
  awayOption?: string;
  status: EnumEventSettleStatus;
  scoringType: EnumScoringType;
  scores: Record<string, ScoreResponse>;
  gameScores: Record<string, ScoreResponse>;
  thirdPartyCode?: string;
}

export enum EnumEventSettleStatus {
  None = 0,
  Settled = 1,
  SettledMultiple = 2,
  Refunded = 4,
  RefundedMultiple = 8,
  SettledCancelled = 16,
  HTSettlement = 32,
  FTSettlement = 64,
  FTRefunded = 128,
  HTSettledMultiple = 256,
  FTSuspendedMatch = 512,
  FHSuspendedMatch = 1024,
  FTCancelled = 2048,
  FHCancelled = 4096,
  FTPostponed = 8192,
  FHPostponed = 16384,
  FTAbandoned = 32768,
  FHAbandoned = 65536,
  FTCompleteEarly = 131072,
  FHCompleteEarly = 262144,
  Pending = 524288,
}

export enum EnumScoringType {
  Unknown = 0,
  Football = 1,
  Golf = 2,
  Badminton = 3,
  BeachSoccer = 4,
  TableTennis = 5,
  BasketBall = 6,
  Tennis = 7,
  MotorSport = 8,
  WinterSport = 9,
  Cricket = 10,
}

export enum EnumResultType {
  HT = 0,
  FT = 1,
  TotalGamesWin = 2,
  TotalSetsWin = 3,
  TotalPointWin = 4,
}

export interface ScoreResponse {
  /** @format int32 */
  home: number;

  /** @format int32 */
  away: number;
}

export interface TournamentResponse {
  /** @format int32 */
  id: number;
  name: string;

  /** @format date-time */
  eventDate: string;
  hasNoWinner: boolean;
  outrights: OutrightResponse[];
}

export interface OutrightResponse {
  /** @format int32 */
  id: number;
  matchCode: string;
  result: OutrightSettleStatus;

  /** @format int32 */
  teamId: number;
  teamName: string;
}

export enum OutrightSettleStatus {
  Unknown = 0,
  Won = 1,
  Lose = 2,
  Refunded = 3,
}

export interface BetBuilderResultMobileResponse {
  matchCode: string;
  marketResults: MarketResultResponse[];
}

export interface MarketResultResponse {
  marketType: MarketType;

  /** @format decimal */
  point?: number;
  isRefunded: boolean;
  selectionResults?: SelectionResultResponse[];
}

export interface MarketType {
  /** @format int32 */
  id: number;
  name: string;
}

export interface SelectionResultResponse {
  outcome: SelectionOutcome;
  name: string;
}

export enum SelectionOutcome {
  NoOutcome = 0,
  WON = 1,
  LOSE = 2,
  REFUND = 3,
  DRAW = 4,
  HALF_WIN = 6,
  HALF_LOSE = 7,
  VOID_SUSPENDED_MATCH = 9,
}

export interface BetBuilderResultResponse {
  marketResults: MarketResultResponse[];
}

export interface DynamicMatchMarketResultResponse {
  results: DynamicMarketResultResponse[];
}

export interface DynamicMarketResultResponse {
  /** @format int64 */
  matchMarketId: number;
  marketName: string;
  isRefunded: boolean;
  selectionResults?: DynamicSelectionResultResponse[];
}

export interface DynamicSelectionResultResponse {
  /** @format int64 */
  matchMarketId: number;
  outcome: SelectionOutcome;
  selectionName: string;

  /** @format int64 */
  selectionId: number;
}

export interface DynamicMarketResultBySelectionResponse {
  winnerSelectionName?: string;
}

export interface MaxPayoutResponse {
  /** @format decimal */
  soccer: number;

  /** @format decimal */
  otherSportsMin: number;

  /** @format decimal */
  otherSportsMax: number;
}

export interface CashOut {
  /** @format int64 */
  tid: number;
  status: CashOutStatus;

  /** @format decimal */
  cov: number;
  isSupported: boolean;

  /** @format decimal */
  fullCashOutValue: number;

  /** @format decimal */
  minStake: number;
  isSupportedPartialCashOut: boolean;
}

export interface AbTestSettingSetupRequest {
  settings: AbTestSetting[];
}

export interface AbTestSetting {
  /** @format int32 */
  groupId: number;
  currency: string;

  /** @format int32 */
  count: number;
}

export type Token = TokenWithExpiryOfToken & {
  d: number[];
  p: string;
  c: boolean;
  i: boolean;
  y: string;
  f: boolean;
  r: boolean;
  q: boolean;
};

export interface TokenWithExpiryOfToken {
  /** @format int32 */
  e: number;
}

export type AuthenticationToken = TokenWithExpiryOfAuthenticationToken & { r: boolean };

export interface TokenWithExpiryOfAuthenticationToken {
  /** @format int32 */
  e: number;
}

export type OddsToken = TokenWithExpiryOfOddsToken & { d: number[]; p: string; y: string };

export interface TokenWithExpiryOfOddsToken {
  /** @format int32 */
  e: number;
}

export enum TiEnumLanguageType {
  None = 0,
  EN = 1,
  ZH_TW = 2,
  ZH_CN = 4,
  JA_JP = 8,
  KO_KR = 16,
  TH_TH = 32,
  VI_VN = 64,
  ID_ID = 128,
  DE_DE = 256,
  ES_ES = 512,
  MY_MM = 1024,
  FR_FR = 2048,
  RU_RU = 4096,
  PT_PT = 8192,
  ZH_CW = 16384,
  TA_IN = 32768,
  HI_IN = 65536,
  PT_BR = 131072,
  KM_KH = 262144,
  BN_BD = 524288,
  MS_MY = 1048576,
}

export interface Bet {
  /** @format int64 */
  id: number;

  /** @format int64 */
  transactionId: number;
  isLive: boolean;
  sportType: TiEnumSportType;
  sportName: string;

  /** @format int32 */
  matchId: number;
  marketType: TiEnumMarketType;
  marketTypeName: string;

  /** @format int32 */
  betTypeGroupId: number;
  betTypeGroup: string;

  /** @format float */
  stake: number;

  /** @format float */
  actualStake: number;
  oddsOptionType: TiEnumOddsOption;
  betTeam: string;
  favoriteTeam: HandicapType;

  /** @format decimal */
  point: number;
  betLiveScore: Score;

  /** @format int32 */
  oddsId: number;

  /** @format int64 */
  selectionId: number;

  /** @format decimal */
  odds: number;
  oddsStyle: DisplayOddStyle;

  /** @format date-time */
  showTime: string;
  showTimeDisplayType: ShowTimeDisplayType;
  homeTeamName: string;
  awayTeamName: string;

  /** @format date-time */
  transactionDate: string;
  mainBetStatus: MainBetStatus;
  betStatus: BetStatus;
  betCondition: string;
  isVoucher: boolean;
  subBets: SubBet[];

  /** @format int32 */
  eventId: number;

  /** @format int32 */
  eventResultId: number;

  /** @format int32 */
  leagueId: number;
  leagueName: string;
  fullTimeScore?: Score;
  halfTimeScore?: Score;
  result?: string;

  /** @format float */
  playerWinLoss: number;

  /** @format float */
  playerCommission: number;

  /** @format date-time */
  eventDate: string;

  /** @format date-time */
  winLostDate: string;
  failBetReason?: FailBetReason;
  partiallyCashedOutBets: PartiallyCashedOutBet[];

  /** @format int64 */
  originalTransactionId: number;

  /** @format float */
  originalStake: number;

  /** @format float */
  originalActualStake: number;

  /** @format float */
  totalCashedOutValue: number;
  isPartialCashOutBet: boolean;

  /** @format float */
  partialCashedOutStake: number;

  /** @format float */
  partialCashedOutActualStake: number;

  /** @format float */
  partialCashedOutValue: number;
  betBuilderLegs: BetBuilderLeg[];

  /** @format float */
  parlayFinalOdds: number;
}

export interface Score {
  /** @format int32 */
  home: number;

  /** @format int32 */
  away: number;
}

export enum DisplayOddStyle {
  Unknown = 0,
  Malay = 1,
  HK = 2,
  Indo = 3,
  Euro = 4,
  Myanmar = 5,
}

export enum MainBetStatus {
  Amended = 1,
  Reversed = 2,
  Draw = 3,
  Lose = 4,
  Refunded = 5,
  WaitingRejected = 6,
  Running = 7,
  SpecialVoid = 8,
  Void = 9,
  Waiting = 10,
  Won = 11,
  CashOut = 12,
}

export enum BetStatus {
  Unknown = 0,
  Running = 1,
  Waiting = 2,
  Won = 3,
  Lose = 4,
  Draw = 5,
  Rejected = 6,
  Void = 7,
  Refunded = 8,
  Special_Void = 9,
  Dangerous_Mp_Void = 13,
  Cashed_Out = 16,
  Cash_Out = 32,
  PartialCashOut = 64,
  I_O_M = 256,
  Special = 512,
  DelaySpecialVoid = 521,
  Dangerous_1 = 1024,
  Dangerous_2 = 2048,
  Dangerous_3 = 4096,
  Cash = 8192,
  Indirect = 16384,
  System_Void = 32768,
  Early_Settled = 65536,
  Delay_Void = 131072,
  TestMode = 262144,
  Resettled = 524288,
  ThirdParty = 1048576,
  FreeBet = 67108864,
  GhostTicket = 134217728,
  MuayStep = 268435456,
  PremiumCricket = 536870912,
  ZeroCommission = 1073741824,
}

export interface SubBet {
  /** @format int64 */
  transactionId: number;
  isLive: boolean;

  /** @format int32 */
  matchId: number;
  sportType: TiEnumSportType;
  sportName: string;
  marketType: TiEnumMarketType;
  marketTypeName: string;

  /** @format int32 */
  betTypeGroupId: number;
  betTypeGroup: string;
  oddsOptionType: TiEnumOddsOption;
  betTeam: string;
  favoriteTeam: HandicapType;

  /** @format decimal */
  point: number;
  betLiveScore: Score;

  /** @format decimal */
  odds: number;

  /** @format date-time */
  showTime: string;
  showTimeDisplayType: ShowTimeDisplayType;
  homeTeamName: string;
  awayTeamName: string;
  subBetStatus: SubBetStatus;
  betCondition: string;

  /** @format int32 */
  eventId: number;

  /** @format int32 */
  eventResultId: number;

  /** @format int32 */
  leagueId: number;
  leagueName: string;
  fullTimeScore?: Score;
  halfTimeScore?: Score;

  /** @format date-time */
  eventDate: string;
  result?: string;
}

export enum SubBetStatus {
  Draw = 1,
  Lose = 2,
  Running = 3,
  Void = 4,
  Waiting = 5,
  Won = 6,
  HalfWon = 7,
  HalfLose = 8,
  Suspended = 9,
  WaitingRejected = 10,
  Done = 11,
  Refund = 12,
}

export interface FailBetReason {
  status: PolluxPlaceOrderStatus;

  /** @format int64 */
  extraInfo: number;
}

export enum PolluxPlaceOrderStatus {
  Unknown = 0,
  Success = 1,
  LiveSuccess = 2,
  EventCheckSuccess = 3,
  EventClosed = 4,
  CreditCheckSuccess = 5,
  MemberSuspend = 6,
  MemberClosed = 7,
  HierarachySuspend = 8,
  HierarachyClosed = 9,
  InsufficientCredit = 10,
  BlackListCheckSuccess = 11,
  InBlackList = 12,
  InvalidPrice = 13,
  PriceChange = 14,
  StakeProblem = 15,
  PriceSuspend = 16,
  AccountProblem = 17,
  MaxBetExceed = 18,
  MaxPerMatchExceed = 19,
  PTProblem = 20,
  ExistBetOnSameEvent = 21,
  LessEvent = 22,
  InvalidRefNo = 23,
  IOMWalkinOnly = 24,
  InvalidCookieIdentity = 25,
  SportExcluded = 26,
  HdpPointChange = 27,
  ScoreChanged = 28,
  BettingBudgetExceed = 29,
  MinBetUnMet = 30,
  MPSubBetCountExceed = 31,
  MPMaxPayoutExceed = 32,
  MPMaxAccumulatedStakeForSubEventExceed = 33,
  FailToFulfillBetCountRestrictionForSplitPoint = 34,
  InvalidVoucher = 35,
  InvalidPriceForVoucher = 36,
  InvalidPriceStyle = 37,
  InvalidIp = 38,
  InvalidPriceId = 39,
  PhoneBetting = 40,
  IsNotSingleBet = 41,
  DeductBalanceFail = 42,
  CountryIsBlock = 43,
  InvalidHttpReferer = 44,
  InvalidPriceStyleForVoucher = 45,
  InvalidAccountForVoucher = 46,
  NotValidMixParlayCombination = 47,
  InvalidCurrencyForVietnam = 48,
  PlayerNotLogin = 49,
  LimitExceed = 50,
  MaxWinLoseLimitExceed = 51,
  ThirdPartyTimeout = 52,
  LimitExceedTryLater = 53,
  BBMaxPayoutExceed = 54,
  BBMaxAccumulatedStakeExceed = 55,
  LessSelection = 56,
  ExistBetWithSameRefNo = 57,
  IncorrectLiveStatus = 58,
  OrderProcessing = 59,
  RetryOpenTicket = 99,
  GeneralFailure = 255,
}

export interface PartiallyCashedOutBet {
  /** @format int64 */
  transId: number;
  partialCashOutBetStatus: BetStatus;

  /** @format date-time */
  winLostDate: string;

  /** @format date-time */
  transDate: string;

  /** @format float */
  stake: number;

  /** @format float */
  actualStake: number;

  /** @format float */
  result: number;

  /** @format float */
  commission: number;
}

export interface BetBuilderLeg {
  /** @format int64 */
  transactionId: number;
  isLive: boolean;
  status: SubBetStatus;

  /** @format int64 */
  refNo: number;
  marketType: KeyValuePairOfIntegerAndString;
  selectionType: KeyValuePairOfIntegerAndString;
  betTeam: string;

  /** @format double */
  point?: number;
  betLiveScore: Score;
}

export interface KeyValuePairOfIntegerAndString {
  /** @format int32 */
  key: number;
  value?: string;
}

export interface Match {
  /** @format int32 */
  matchId: number;
  matchCode: string;

  /** @format int32 */
  leagueId: number;
  leagueName: string;
  homeTeamName: string;
  awayTeamName: string;

  /** @format date-time */
  showTime: string;
  showTimeDisplayType: ShowTimeDisplayType;
  firstGoal: EnumResultFGLG;
  lastGoal: EnumResultFGLG;
  results?: MatchResult[];
  betBuilderMarketResults: MarketResult[];
  hasBetBuilderResults: boolean;
  hasDynamicMarketResults: boolean;
  leaguePriority: string;
  matchCodeWithoutLeaguePriority: string;
}

export interface MatchResult {
  /** @format int32 */
  matchResultId: number;

  /** @format int32 */
  betTypeGroupId: number;
  betTypeGroupName: string;
  homeOption: string;
  awayOption: string;
  status: EnumEventSettleStatus;
  scoringType: EnumScoringType;
  scores: Record<string, Score>;
  gameScores: Record<string, Score>;
  thirdPartyCode?: string;
}

export interface MarketResult {
  selectionResults: SelectionResult[];

  /** @format decimal */
  point?: number;
  name: string;

  /** @format int32 */
  id: number;
}

export interface SelectionResult {
  outcome: SelectionOutcome;
  name: string;
}

export interface DateRange {
  /** @format date-time */
  from: string;

  /** @format date-time */
  to: string;
}

export interface Tournament {
  /** @format int32 */
  id: number;
  name: string;

  /** @format date-time */
  eventDate: string;
  hasNoWinner: boolean;
  outrights: Outright[];
}

export interface Outright {
  /** @format int32 */
  id: number;
  matchCode: string;
  result: OutrightSettleStatus;

  /** @format int32 */
  teamId: number;
  teamName: string;
}

export interface DomainTypeResponse {
  isNumberSite: boolean;
  isSboTop: boolean;
  isSbotop123: boolean;
  isSboTopPureDomain: boolean;
  isB2BPureDomain: boolean;
  isMainDomain: boolean;
  isHttps: boolean;
}

export interface AccountInfoResponseDto {
  /** @format int32 */
  customerId: number;
  loginName: string;
  accountId: string;
  sboCurrency: string;
  isoCurrency: string;
  isIom: boolean;
  isJoinNow: boolean;
  isB2B2C: boolean;
  isTestMode: boolean;
  isQuarantined: boolean;

  /** B2c Resident Country */
  country?: string;
  playerType: PlayerType;
}

export interface Tokens {
  oldToken: string;
  authToken: string;
  oddsToken: string;
  sm: MarkedOddsToken;
  om: MarkedOddsToken;
}

export interface MarkedOddsToken {
  b: string;
  m: string;
  s: string;
  e: string | null;
}

export interface MyBetsResponse {
  runningBets: Bet[];
  settledBets: Bet[];
}

export interface RunningBetCountResponse {
  /** @format int32 */
  singleBet: number;

  /** @format int32 */
  multipleBet: number;

  /** @format int32 */
  outrightBet: number;

  /** @format int32 */
  cashOutBet: number;

  /** @format int32 */
  cashOutMixParlayBet: number;

  /** @format int32 */
  betBuilderBetCount: number;
}

export interface TokensResponse {
  authToken: string;
  sm: MarkedOddsToken;
  om: MarkedOddsToken;
}

export interface GenerateTelegramLinkResponse {
  /** @format int32 */
  errorCode: number;
  errorMessage: string;
  inviteLink: string;
}

export interface SettingRequest {
  priceStyle?: TiEnumPriceStyle;
  isAcceptAnyOdds?: boolean;
  isAcceptAnyCashOutValue?: boolean;
  oddsDisplayMode?: OddsDisplayMode;
  oddsSorting?: OddsSorting;
  displayTime?: DisplayTime;
  siteStyle?: SiteStyle;
  playSound?: string;
}

export interface SelectedLeagueInfoRequest {
  sportType: TiEnumSportType;

  /** @format int32 */
  marketPage: number;

  /** @format int32 */
  eventDate: number;

  /** @format int32 */
  daylightType: number;
  leagueIds: number[];
  isSelectAllBigLeagues: boolean;
}

export interface SelectedLeagueInfoResponse {
  sportType: TiEnumSportType;

  /** @format int32 */
  marketPage: number;

  /** @format int32 */
  eventDate: number;

  /** @format int32 */
  daylightType: number;
  leagueIds: number[];
  isSelectAllBigLeagues: boolean;
}

export interface Voucher {
  /** @format int64 */
  id: number;

  /** @format date-time */
  expiryDate: string;

  /** @format decimal */
  stake: number;
}

export interface LogoutRequest {
  /** @format int32 */
  customerId: number;
}

export interface PlaceFantasySelectionBetResponse {
  transId?: string;
  placeOrderStatus: FantasySelectionOrderStatus;
}

export enum FantasySelectionOrderStatus {
  Unknown = 0,
  Success = 1,
  ContestClosed = 10,
  PoolFull = 11,
  MemberSuspend = 20,
  MemberClosed = 21,
  AccountProblem = 22,
  TestAccountBettingDisabled = 23,
  HasDepositBonus = 24,
  BettingBudgetExceeded = 25,
  UserNotTestAccount = 26,
  InsufficientCredit = 30,
  StakeOverThanMaxBet = 31,
  StakeLowerThanMinBet = 32,
  GeneralFailure = 255,
}

export interface PlaceFantasySelectionBetRequest {
  /** @format int32 */
  contestId: number;

  /** @format int32 */
  poolId: number;

  /** @format decimal */
  stake: number;
  selectedTeamIds: number[];

  /** @format int32 */
  betPage?: number;
}

export interface FantasySelectionMyBetsResponse {
  runningBets: FantasySelectionBetResponse[];
  settledBets: FantasySelectionBetResponse[];
}

export interface FantasySelectionBetResponse {
  /** @format int64 */
  betId: number;
  refNo: string;
  contest: BetContestResponse;
  pool: PoolResponse;

  /** @format decimal */
  stake: number;

  /** @format date-time */
  betTime: string;
  status: FantasySelectionBetStatus;

  /** @format date-time */
  winLostDate?: string;

  /** @format decimal */
  winLost?: number;
  sportType: TiEnumSportType;

  /** @format decimal */
  playerCommission: number;
  leagues: BetLeagueResponse[];

  /** @format int32 */
  myRank?: number;
  selections: FantasySelectionResponse[];
}

export interface BetContestResponse {
  /** @format int32 */
  id: number;
  name: string;
  status: ContestStatus;
}

export enum ContestStatus {
  Unknown = 0,
  Running = 1,
  Closed = 2,
  PendingResult = 3,
  Completed = 4,
}

export interface PoolResponse {
  /** @format int64 */
  id: number;

  /** @format decimal */
  entryFee: number;

  /** @format decimal */
  prizePool: number;

  /** @format int32 */
  currentEntries: number;

  /** @format int32 */
  maxEntries: number;
}

export enum FantasySelectionBetStatus {
  Running = 0,
  Won = 1,
  Lost = 2,
  Refunded = 3,
  Amended = 4,
  Reversed = 5,
}

export interface BetLeagueResponse {
  /** @format int32 */
  id: number;
  name: string;
}

export interface FantasySelectionResponse {
  /** @format int32 */
  id: number;
  name: string;
}

export interface FantasySelectionBetCountResponse {
  /** @format int32 */
  runningBetCount: number;
}

export interface FantasySelectionMyBetDetailResponse {
  contest: ContestResponse;
  rankings: RankingResponse[];

  /** @format decimal */
  stake: number;
  betStatus: FantasySelectionBetStatus;

  /** @format decimal */
  prizePool: number;
}

export interface ContestResponse {
  /** @format int32 */
  id: number;
  name: string;

  /** @format date-time */
  startTime: string;

  /** @format date-time */
  endTime: string;
  pool: PoolResponse;
  leagues: ContestLeagueResponse[];
  matches: FantasySelectionMatchResponse[];
}

export interface ContestLeagueResponse {
  /** @format int32 */
  id: number;
  name: string;
}

export interface FantasySelectionMatchResponse {
  /** @format int32 */
  matchId: number;

  /** @format int32 */
  leagueId: number;
  homeTeam: FantasySelectionTeamResponse;
  awayTeam: FantasySelectionTeamResponse;

  /** @format date-time */
  kickoffTime: string;

  /** @format int32 */
  homeScore?: number;

  /** @format int32 */
  awayScore?: number;
}

export interface FantasySelectionTeamResponse {
  /** @format int32 */
  id: number;
  name: string;
}

export interface RankingResponse {
  /** @format int32 */
  rank: number;
  playerName: string;

  /** @format decimal */
  points: number;
  selections: FantasySelectionResponse[];
}

export interface FantasySelectionTokenResponse {
  token: string;
}

export interface BetBuilderTicketResponse {
  /** @format int32 */
  matchId: number;
  markets: BetBuilderMarketResponse[];

  /** @format decimal */
  maxBet?: number;

  /** @format decimal */
  minBet?: number;
  price: PriceResponse;
  status: CompositeMarketStatus;
  uid: string;
  selectedMarketSelections: SelectedMarketSelectionResponse[];

  /** @format decimal */
  balance?: number;
}

export interface BetBuilderMarketResponse {
  /** @format int32 */
  matchMarketId: number;
  selections: BetBuilderMarketSelectionResponse[];
}

export interface BetBuilderMarketSelectionResponse {
  /** @format int32 */
  selectionId: number;
  status: SelectionStatus;
  isCompatible: boolean;
  price?: Price;
}

export enum SelectionStatus {
  Unknown = 0,
  Running = 1,
  Suspended = 2,
  Internal = 3,
  Closed = 4,
  Incompatible = 5,
}

export interface Price {
  /** @format decimal */
  value: number;
  style: TiEnumPriceStyle;
}

export interface PriceResponse {
  /** @format decimal */
  value: number;
  style: TiEnumPriceStyle;
}

export enum CompositeMarketStatus {
  Unknown = 0,
  Available = 1,
  Unavailable = 2,
  InsufficientLegs = 3,
  MaxLegCountExceeded = 4,
  RedundantSelection = 5,
  IncompatibleSelection = 6,
}

export interface SelectedMarketSelectionResponse {
  /** @format int32 */
  selectionId: number;
  status: SelectionStatus;
  isRedundant: boolean;
  liveScore: Score;
}

export interface BetBuilderTicketRequest {
  isLive: boolean;
  selectionIds: number[];
}

export interface BetBuilderOrderResponse {
  /** @format int64 */
  transId: number;
  selectionIds: number[];
  placeOrderStatus: PolluxPlaceOrderStatus;
  price: Price;
  orderStatus: TiEnumStatementDetailStatus;
  isPlaceBetSuccess: boolean;
  isAccountClosed: boolean;
}

export enum TiEnumStatementDetailStatus {
  Unknown = 0,
  Running = 1,
  Waiting = 2,
  Won = 3,
  Lose = 4,
  Draw = 5,
  Rejected = 6,
  Void = 7,
  Refunded = 8,
  Special_Void = 9,
  HalfWon = 10,
  HalfLose = 11,
  SuspendVoid = 12,
  Dangerous_Mp_Void = 13,
  CashOut = 16,
  CashOutBet = 32,
}

export type BetBuilderOrderRequest = BasePlaceOrderRequest & { selections: BetBuilderSelectionRequest[] };

export interface BetBuilderSelectionRequest {
  /** @format int32 */
  id: number;
  liveScore: Score;
}

export interface BasePlaceOrderRequest {
  uid: string;

  /** @format decimal */
  stake: number;

  /** @format byte */
  betPage: number;
}

export interface RemoveSingleTicket {
  uid: string;
}

export interface DynamicMarketTicketResponse {
  /** @format decimal */
  minBet: number;

  /** @format decimal */
  balance?: number;

  /** @format decimal */
  maxBet: number;
  selection?: SelectionResponse;
  error: ErrorResponse;
  uid: string;
}

export interface SelectionResponse {
  price?: Price;
  betCondition?: string;
  score?: Score;
}

export interface ErrorResponse {
  code: OpenTicketStatus;
  description?: string;
}

export enum OpenTicketStatus {
  Success = 0,
  InvalidInput = 1,
  EventCompleted = 2,
  EventClosed = 3,
  EventInternal = 4,
  OddsClosed = 5,
  OddsInternal = 6,
  OddsCompleted = 7,
  MaxOddsExceed = 8,
  InvalidPrice = 9,
}

export interface DynamicMarketTicketRequest {
  /** @format int64 */
  selectionId: number;
}

export interface DynamicMarketOrderResponse {
  /** @format int64 */
  transId: number;

  /** @format int64 */
  selectionId: number;
  placeOrderStatus: PolluxPlaceOrderStatus;
  orderStatus: TiEnumStatementDetailStatus;
  isPlaceBetSuccess: boolean;
  extraInfo?: any;
}

export type DynamicMarketOrderRequest = BasePlaceOrderRequest & {
  selectionId: number;
  matchId: number;
  voucherId?: number;
};

export interface TicketResponse {
  /** @format decimal */
  minBet: number;

  /** @format decimal */
  maxBet: number;

  /** @format decimal */
  balance?: number;
  oddsInfo?: Record<string, TicketOddsInfo>;
  errorCode: OpenTicketStatus;
}

export interface TicketOddsInfo {
  betCondition?: string;

  /** @format int32 */
  liveAwayScore: number;

  /** @format int32 */
  liveHomeScore: number;

  /** @format int32 */
  oddsId: number;

  /** @format decimal */
  point: number;

  /** @format decimal */
  price: number;
  priceStyle: TiEnumPriceStyle;
  errorCode?: OpenTicketStatus;
  uid?: string;
}

export type OutrightTicketInfo = TicketInfo & { leagueId: number };

export interface TicketInfo {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  oddsId: number;
  option: string;
  sportType: TiEnumSportType;
  marketType: TiEnumMarketType;

  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  eventId: number;
  isLive: boolean;
}

export interface OrderResponse {
  isPlaceBetSuccess: boolean;

  /** @format int64 */
  transId: number;
  placeOrderStatus: PolluxPlaceOrderStatus;

  /** @format decimal */
  price: number;
  orderStatus: TiEnumStatementDetailStatus;

  /** @format int32 */
  oddsId: number;
  option?: string;
  message: string;
  extraInfo?: any;
}

export type PlaceOutrightOrderRequest = BasePlaceOrderRequest & {
  outrightId: number;
  sportType: TiEnumSportType;
  leagueId: number;
  isLive: boolean;
};

export type TicketMpResponse = TicketResponse & { mpUid: string };

export type PlaceComboParlayOrderRequest = BasePlaceOrderRequest & {
  mpBet: MixParlaySubBet[];
  selectedCombo: number[];
};

export interface MixParlaySubBet {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  eventId: number;

  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  oddsId: number;
  marketType: TiEnumMarketType;
  option: string;

  /** @format int32 */
  leagueId: number;
  liveScore: Score;

  /** @format decimal */
  point: number;
}

export type PlaceSingleOrderRequest = BasePlaceOrderRequest & {
  oddsId: number;
  sportType: TiEnumSportType;
  marketType: TiEnumMarketType;
  option: string;
  eventId: number;
  voucherIdString?: string;
  liveScore: Score;
  point: number;
};

export interface BetListMaxOddsMixParlayBetsParams {
  lang?: string;

  /** @format int32 */
  limit?: number | null;
  isoCurrency?: string;
}

export interface BetListMaxOddsBetsByMinSubBetParams {
  lang?: string;

  /** @format int32 */
  limit?: number | null;
  isoCurrency?: string;
}

export interface ConfigurationSettingsParams {
  project?: 0 | 1 | 2 | 3 | 4;
  siteStyle?: 0 | 1 | 2;
}

export interface ConfigurationLocationParams {
  domain?: string | null;
}

export interface InternalPromotionGetTeamRankingParams {
  stage?: 1 | 2 | 3;
}

export interface InternalPromotionGetIndividualRankingParams {
  stage?: 1 | 2 | 3;
}

export interface LiveStreamGetLiveStreamUrlParams {
  /** @format int32 */
  matchId?: number;

  /** @format int32 */
  streamId?: number;
  liveStreamType?: 1 | 2 | 3 | 4;
}

export interface MatchResultGetMatchResultsParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format date-time */
  resultDate?: string;
}

export interface MatchResultGetOutrightTournamentResultsParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format date-time */
  startDate?: string;

  /** @format date-time */
  endDate?: string;
}

export interface MatchResultGetBetBuilderResultsParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format date-time */
  resultDate?: string;
}

export interface MatchResultGetBetBuilderResultParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format int32 */
  matchId?: number;
}

export interface MatchResultGetDynamicMarketResultParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format int32 */
  matchId?: number;
}

export interface MatchResultGetDynamicMarketResultBySelectionParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format int32 */
  matchId?: number;

  /** @format int64 */
  selectionId?: number;
}

export interface MgmtGetIpCountryCodeParams {
  ip?: string;
}

export interface MgmtGlobalSettingParams {
  key?: string | null;
}

export interface MgmtConfigurationParams {
  key?: string | null;
}

export interface MgmtTestCashOutConnectionParams {
  /** @format int64 */
  transactionId?: number;
}

export interface MgmtGetDistributedCacheParams {
  key?: string;
}

export interface MgmtSetDistributedCacheParams {
  key?: string;
  value?: string;
}

export interface MgmtSetupAbTestSettingParams {
  /** @format int32 */
  groupId?: number;

  /** @format int32 */
  count?: number;
  currency?: string;
}

export interface MgmtDeleteAbTestGroupByIdParams {
  /** @format int32 */
  testId?: number;
}

export interface MgmtOddsApiTokenParams {
  /** @format int32 */
  expiryMinutes?: number;
}

export interface MgmtOddsApiTokenDecryptParams {
  token?: string;
}

export interface MgmtOddsApiAuthenticationTokenDecryptParams {
  token?: string;
}

export interface MgmtOddsApiOddsTokenDecryptParams {
  token?: string;
}

export interface MgmtTestHttpStatusGetParams {
  code?: string;
}

export interface MgmtTestHttpStatusPostParams {
  code?: string;
}

export interface MgmtBetListApiGetRunningBetListParams {
  /** @format int32 */
  customerId?: number | null;
  language?:
    | "0"
    | "1"
    | "2"
    | "4"
    | "8"
    | "16"
    | "32"
    | "64"
    | "128"
    | "256"
    | "512"
    | "1024"
    | "2048"
    | "4096"
    | "8192"
    | "16384"
    | "32768"
    | "65536"
    | "131072"
    | "262144"
    | "524288"
    | "1048576";
}

export interface MgmtBetListApiGetSettledBetListParams {
  /** @format int32 */
  customerId?: number | null;

  /** @format date-time */
  from?: string | null;

  /** @format date-time */
  to?: string | null;
  language?:
    | "0"
    | "1"
    | "2"
    | "4"
    | "8"
    | "16"
    | "32"
    | "64"
    | "128"
    | "256"
    | "512"
    | "1024"
    | "2048"
    | "4096"
    | "8192"
    | "16384"
    | "32768"
    | "65536"
    | "131072"
    | "262144"
    | "524288"
    | "1048576";
}

export interface MgmtGetMiniMyBetParams {
  /** @format int32 */
  customerId?: number | null;
  language?:
    | "0"
    | "1"
    | "2"
    | "4"
    | "8"
    | "16"
    | "32"
    | "64"
    | "128"
    | "256"
    | "512"
    | "1024"
    | "2048"
    | "4096"
    | "8192"
    | "16384"
    | "32768"
    | "65536"
    | "131072"
    | "262144"
    | "524288"
    | "1048576";
}

export interface MgmtGetMatchResultsParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;
}

export interface MgmtGetOutrightResultsParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format date-time */
  startDate?: string;

  /** @format date-time */
  endDate?: string;
}

export interface MgmtGetDomainTypeDirectlyFromForsetiParams {
  domain?: string;
}

export interface MgmtGetAccountInfoParams {
  /** @format int32 */
  custId?: number;
  loginApiToken?: string;
  countryCode?: string;
}

export interface MgmtGenerateMultipleOddsTokensParams {
  /** @format int32 */
  count?: number;

  /** @format int32 */
  expiryMinutes?: number;
}

export interface MgmtClearFeatureEventRecordsParams {
  customerIds?: string | null;
}

export interface MyBetListMiniMyBetsParams {
  c?: boolean;
}

export interface MyBetListMyBetListParams {
  c?: boolean;
}

export interface MyBetListSettledBetListParams {
  /** @format date-time */
  winLostDate?: string;
}

export interface MyBetListGetRunningBetCountParams {
  c?: boolean;
}

export interface TelegramGenerateTelegramLinkParams {
  /** @format int32 */
  TimezoneOffsetMinutes?: number;
}

export interface VoucherGetAllParams {
  sportType?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39;

  /** @format int32 */
  leagueId?: number;
}

export interface WelcomeCreateSessionParams {
  id?: string;
}

export interface WelcomeProductSwitchParams {
  id?: string;
}

export interface MyBetListSettledBetList2Params {
  /** @format date-time */
  winLostDate?: string;
}

export interface MyBetListMyBetDetailParams {
  refNo?: string;
}
